import {
  UpdateEventListener,
  FireableUpdateEventListener
} from 'utils/UpdateEventListener';
import {
  AddonFeatureManager,
  AgencyManager,
  DefaultAgencyManager,
  LocaleMeta
} from 'core';
import {
  LimitationManager,
  DefaultLimitationManager
} from 'core/limitation/LimitationManager';
import {
  DeliverType,
  RtbCampaignPlanType,
  CreativeDeliverType,
  AdType,
  VideoAdViewObjective,
  CampaignState,
  RTBCAMPAIGN_DEFAULT_AGE_MIN,
  RTBCAMPAIGN_DEFAULT_AGE_MAX,
  RtbCampaign,
  OutdoorDeliverType,
  TrackEvent,
  RtbCampaignListBasic,
  RtbCampaignFormData,
  isOneForAllAdType
} from 'core/rtbCampaign/RtbCampaign';
import { isEpaperChannelGroup } from 'core/channelGroup/EpaperChannelGroup';
import { FinalReportGender, Order, State } from 'core/order/Order';
import {
  DefaultRtbCampaignManager,
  RtbCampaignManager
} from 'core/rtbCampaign/RtbCampaignManager';
import {
  RtbCampaignBasicFormModel,
  RtbCampaignBasicFormModelConstructorParams
} from './RtbCampaignForm/RtbCampaignBasicFormModel';
import {
  DefaultEditLimitationModel,
  EditLimitationModel
} from 'containers/Limitations/EditLimitationModel';
import { OPERATE, OPERATES } from 'enum/Operate';
import moment from 'moment';
import i18n from 'i18next';
import _ from 'lodash';
import { getPriceValue } from 'helper/CurrencyHelper';
import { ADDONFEATURE, perChannelCampaignKey } from 'core/agency/AddonFeature';
import { L1Object, L1ObjectChannel } from 'core/l1Object/L1Object';
import {
  AdRequestSourceManager,
  DefaultAdRequestSourceManager
} from 'core/adRequestSource/AdRequestSourceManager';
import {
  EditOneForAllDisplayFormModel,
  OneForAllDisplayFormModel
} from './RtbCampaignForm/OneForAllDisplayFormModel';
import {
  UnknowAdTypeFormModel,
  CreateUnknowAdTypeFormModel,
  EditUnknowAdTypeFormModel
} from './RtbCampaignForm/UnknowAdTypeFormModel';
import { BidStrategy, L2ObjectOptimizationGoal } from 'core/l2Object/L2Object';
import {
  DefaultRtbCampaignSummaryStepModel,
  RtbCampaignDraftSummaryStepModel,
  RtbCampaignSummaryStepModel
} from './FlowSteps/RtbCampaignSummaryStepModel';
import {
  isTestMode,
  overlayLimitationData,
  toServerStructure
} from 'utils/LimitationUtil';
import {
  getGenderOptions,
  getPmax2RtbAgeGroupsByAgeRange
} from 'core/limitation/l2ObjectTAOptions';
import { EstimatedAudience } from 'core/limitation/Limitation';
import {
  Limitation,
  SavedTargeting,
  LimitationData
} from 'core/limitation/Limitation';
import { SummaryTitleColor } from 'components/SummaryDetail/SummaryDetail';
import { DraftManager, RtbCampaignDraftManager } from 'core/draft/DraftManager';
import { toast } from 'react-toastify';
import {
  CreateDisplayFormModel,
  DisplayFormModel,
  EditDisplayFormModel
} from './RtbCampaignForm/DisplayFormModel';
import {
  CreateVideoFormModel,
  EditVideoFormModel,
  VideoFormModel
} from './RtbCampaignForm/VideoFormModel';
import {
  ComboFormModel,
  CreateComboFormModel,
  EditComboFormModel
} from './RtbCampaignForm/ComboFormModel';
import {
  CreateThirdPartyBottomFormModel,
  EditThirdPartyBottomFormModel,
  ThirdPartyBottomFormModel
} from './RtbCampaignForm/ThirdPartyBottomFormModel';
import {
  CreateThirdPartyRectangleFormModel,
  EditThirdPartyRectangleFormModel,
  ThirdPartyRectangleFormModel
} from './RtbCampaignForm/ThirdPartyRectangleFormModel';
import {
  CtvFormModel,
  CreateCtvFormModel,
  EditCtvFormModel
} from './RtbCampaignForm/CTVFormModel';
import {
  CreateThirdPartyFormModel,
  EditThirdPartyFormModel,
  ThirdPartyFormModel
} from './RtbCampaignForm/ThirdPartyFormModel';
import { LIMITATION_TYPE } from 'containers/Limitations/LimitationSetting/limitationConfig/limitationSettingsType';
import {
  CreatePmpFormModel,
  EditPmpFormModel,
  PmpFormModel
} from './RtbCampaignForm/PmpFormModel';
import { Pmp, PmpStatus } from 'core/pmp/Pmp';
import { DefaultPmpManager, PmpManager } from 'core/pmp/PmpManager';
import {
  BindCreativeInL2ObjectSetupFlowPageModel,
  CreateCreativeInL2ObjectSetupFlowPageModel
} from 'containers/Creatives/CreativeSetupFlow/CreativeSetupFlowPageModel';
import { AdLogoType } from 'core/adLogo/AdLogo';
import { CreativeSummaryStepModel } from 'containers/Creatives/CreativeSetupFlow/FlowSteps/CreativeSummaryStepModel';
import { getDefaultLimitationInventorySettings } from 'containers/Limitations/LimitationSetting/limitationConfig/defaultLimitationInventorySettings';
import {
  CreateSandboxOutdoorFormModel,
  EditSandboxOutdoorFormModel,
  SandboxOutdoorFormModel
} from './RtbCampaignForm/SandboxOutdoorFormModel';
import {
  AbstractOutdoorLimitationCampaignFormModel,
  OutdoorLimitaitonCampaignFormModel
} from './RtbCampaignForm/OutdoorLimitationCampaignFormModel';
import { CreateCreativeStep } from './FlowSteps/CreateCreativeStep';
import { BindCreativeStep } from './FlowSteps/BindCreativeStep';
import {
  CreateLineMessageFormModel,
  EditLineMessageFormModel
} from './RtbCampaignForm/LineMessageFormModel';
import {
  CreateDynamicOutdoorDeviceFormModel,
  DynamicOutdoorDeviceFormModel,
  EditDynamicOutdoorDeviceFormModel
} from './RtbCampaignForm/DynamicOutdoorDeviceFormModel';
import {
  CreateDynamicOutdoorStoreFormModel,
  DynamicOutdoorStoreFormModel,
  EditDynamicOutdoorStoreFormModel
} from './RtbCampaignForm/DynamicOutdoorStoreFormModel';
import {
  CampaignAdTypeSetting,
  ChannelGroupSetting
} from 'core/channelGroup/ChannelGroupSettings';
import {
  CreateSandboxMovableOutdoorFormModel,
  EditSandboxMovableOutdoorFormModel,
  SandboxMovableOutdoorFormModel
} from './RtbCampaignForm/SandboxMovableOutdoorFormModel';
import {
  CreateDynamicMovableOutdoorFormModel,
  DynamicMovableOutdoorFormModel,
  EditDynamicMovableOutdoorFormModel
} from './RtbCampaignForm/DynamicMovableOutdoorFormModel';
import {
  ChannelType,
  DeliveryUnit,
  ScreenDisplayType
} from 'core/channelGroup/ChannelGroup';
import {
  CreateDynamicOutdoorSynchronizedPlaybackFormModel,
  DynamicOutdoorSynchronizedPlaybackFormModel,
  EditDynamicOutdoorSynchronizedPlaybackFormModel
} from './RtbCampaignForm/DynamicOutdoorSynchronizedPlaybackFromModel';

export type CreativeSetupStepData = {
  component: React.ElementType;
  props: {
    model?:
      | CreateCreativeInL2ObjectSetupFlowPageModel
      | BindCreativeInL2ObjectSetupFlowPageModel;
    forPmp: boolean;
  };
};

export interface RtbCampaignSetupFlowPageModel {
  readonly type: string;
  readonly objectType: string;
  readonly order: Order;
  readonly addonFeatureManager: AddonFeatureManager;
  readonly state: RtbCampaignSetupFlowPageState;
  readonly event: UpdateEventListener<RtbCampaignSetupFlowPageModel>;
  readonly limitationModel?: EditLimitationModel;
  readonly campaignBasicFormModel?: RtbCampaignBasicFormModel;
  readonly limitationPreSet?: Partial<LimitationData>;
  readonly campaignId: number | string | null;
  readonly needSetupTracking: boolean;
  readonly l1Object: L1Object;
  readonly localeMeta?: LocaleMeta;
  readonly estimatedAudience?: EstimatedAudience;
  readonly audienceLowestThreshold: number;
  readonly savedTAList: SavedTargeting[];
  readonly appliedSavedTAInfo?: SelectOptions;
  readonly isPmp: boolean;
  readonly pmpList: Pmp[];
  readonly adTypeSetting?: CampaignAdTypeSetting;
  init(): void;
  setCampaign(campaign: RtbCampaignFormData, rerender?: boolean): void;
  getRtbCampaignBasicFormModel(): RtbCampaignBasicFormModel | undefined;
  getLimitationModel(needRefreshSetting: boolean): EditLimitationModel;
  getTitle(): string;
  onAdTypeChange(adType: string, adTypeId?: number): Promise<void>;
  onUnmount(handler): void;
  setOrder(order: Order): void;
  setRedirectPath(redirectPath?: string): void;
  setFinishedRedirectPath(redirectPath?: string): void;
  cancel(): void;
  getRtbCampaignSummaryStepModel(
    subStepIndex: number,
    goLast: () => void,
    goStep: (stepIndex: number, subStepIndex?: number) => void,
    goSubStep: (subStepIndex: number) => void,
    creativeSummaryStepModel?: CreativeSummaryStepModel
  ): RtbCampaignSummaryStepModel;
  getLimitationsSummaryData(limitations): any;
  setShowTAManagement(showTAManagement: boolean): void;
  importLimitation(
    appliedSavedTAInfo: SelectOptions,
    limitationValue: any
  ): void;
  onDeleteSaveTA(deletedTAId: number);
  onSaveDraft?: (campaign: RtbCampaign) => void;
  setCreativeSetupStepData(createNewCreative: boolean): void;
  updateState(loading: boolean): void;
}

export type RtbCampaignSetupFlowPageProps = {
  readonly model: RtbCampaignSetupFlowPageModel;
};

export type RtbCampaignSetupFlowPageState = {
  readonly loading: boolean;
  readonly redirectPath?: string;
  readonly campaign?: RtbCampaignFormData;
  readonly finished: boolean;
  readonly showTAManagement: boolean;
  readonly creativeSetupStepData: CreativeSetupStepData | undefined;
};

export abstract class DefaultRtbCampaignSetupFlowPageModel implements RtbCampaignSetupFlowPageModel {
  objectType: string;
  event: FireableUpdateEventListener<RtbCampaignSetupFlowPageModel>;
  loading: boolean;
  redirectPath?: string;
  addonFeatureManager: AddonFeatureManager;
  campaign?: RtbCampaignFormData;
  defaultCampaign: any;
  limitationPreSet: Partial<LimitationData> = {};
  order: Order;
  campaignOneForAllDisplayFormModel?: OneForAllDisplayFormModel;
  campaignDisplayFormModel?: DisplayFormModel;
  campaignVideoFormModel?: VideoFormModel;
  campaignPICShortFormModel?: OutdoorLimitaitonCampaignFormModel;
  campaignPICLongFormModel?: OutdoorLimitaitonCampaignFormModel;
  campaignPICExtendedFormModel?: OutdoorLimitaitonCampaignFormModel;
  campaignPICBroadFormModel?: OutdoorLimitaitonCampaignFormModel;
  campaignHwacomShortFormModel?: OutdoorLimitaitonCampaignFormModel;
  campaignHwacomLongFormModel?: OutdoorLimitaitonCampaignFormModel;
  campaignHwacomExtendedFormModel?: OutdoorLimitaitonCampaignFormModel;
  campaignHwacomBroadFormModel?: OutdoorLimitaitonCampaignFormModel;
  campaignSandboxOutdoorFormModel?: SandboxOutdoorFormModel;
  campaignComboFormModel?: ComboFormModel;
  campaignCtvFormModel?: CtvFormModel;
  campaignUnknowAdTypeFormModel?: UnknowAdTypeFormModel;
  campaignThirdPartyFormModel?: ThirdPartyFormModel;
  campaignThirdPartyBottomFormModel?: ThirdPartyBottomFormModel;
  campaignThirdPartyRectangleFormModel?: ThirdPartyRectangleFormModel;
  campaignPmpFormModel?: PmpFormModel;
  campaignLineMessageFormModel?: OutdoorLimitaitonCampaignFormModel;
  campaignDynamicOutdoorDeviceFormModel?: DynamicOutdoorDeviceFormModel;
  campaignDynamicOutdoorStoreFormModel?: DynamicOutdoorStoreFormModel;
  campaignDynamicOutdoorSynchronizedPlaybackFormModel?: DynamicOutdoorSynchronizedPlaybackFormModel;
  campaignSandboxMovableOutdoorFormModel?: SandboxMovableOutdoorFormModel;
  campaignDynamicMovableOutdoorFormModel?: DynamicMovableOutdoorFormModel;
  campaignBasicFormModel?: RtbCampaignBasicFormModel;
  campaignSummaryModel?: RtbCampaignSummaryStepModel;
  limitationModel?: EditLimitationModel;
  rbLimitationModel: any;
  normalLimitationModel?: EditLimitationModel;
  finished: boolean;
  savedTAList: SavedTargeting[] = [];
  showTAManagement = false;
  appliedSavedTAInfo?: SelectOptions;
  pmpList: Pmp[] = [];
  createCreativeFlowModel?: CreateCreativeInL2ObjectSetupFlowPageModel;
  bindCreativeFlowModel?: BindCreativeInL2ObjectSetupFlowPageModel;
  createCreativeEventHandler?: number;
  bindCreativeEventHandler?: number;
  creativeSetupStepData?: CreativeSetupStepData;
  channelGroupSetting: ChannelGroupSetting;
  adTypeSetting?: CampaignAdTypeSetting;

  constructor(
    order: Order,
    addonFeatureManager: AddonFeatureManager,
    public l1Object: L1Object,
    public localeMeta?: LocaleMeta,
    protected otherCampaignOfL1Object?: RtbCampaignListBasic[],
    protected manager: RtbCampaignManager = new DefaultRtbCampaignManager(),
    protected limitationManager: LimitationManager = new DefaultLimitationManager(),
    protected adRequestSourceManager: AdRequestSourceManager = new DefaultAdRequestSourceManager(),
    protected pmpManager: PmpManager = new DefaultPmpManager(),
    protected agencyManager: AgencyManager = new DefaultAgencyManager()
  ) {
    this.objectType = 'campaign';
    this.order = { ...order };
    this.l1Object = { ...l1Object };
    this.addonFeatureManager = addonFeatureManager;
    this.manager = manager;
    this.limitationManager = limitationManager;
    this.event =
      new FireableUpdateEventListener<RtbCampaignSetupFlowPageModel>();
    this.loading = true;
    this.finished = false;
    this.channelGroupSetting = ChannelGroupSetting.fromKey(l1Object.channel);
  }

  abstract get type();

  abstract get campaignId();

  abstract getCampaign();

  abstract getTitle();

  abstract to404();

  abstract createCampaignFormModels();

  abstract isCampaignInvalid(): boolean;

  async init() {
    this.updateState(true);
    try {
      await this.initSavedTAList();
      this.limitationPreSet =
        await this.limitationManager.getLimitationPreSet('campaign');
      this.campaign = await this.getCampaign();
      if (
        this.type !== 'summary' &&
        isOneForAllAdType(this.campaign?.basic.adType)
      ) {
        this.cancel();
        this.updateState(false);
        return;
      }
      this.initBidStrategy();
      this.initHiddenFieldsOfEpaperCampaign();
      this.defaultCampaign = _.cloneDeep(this.campaign);
      this.createCampaignFormModels();
      await this.setUpCampaignBasicFormModel(
        this.campaign!.basic.adType,
        this.campaign!.basic.adTypeId
      );
      // summary 路由不 render setup step，不會建 limitation model，所以不能
      // 只靠 getNormalLimitationModel 那一次 overlay（POS-8118）。
      if (this.campaignBasicFormModel) {
        this.applyOutdoorLabelOverlay(
          this.campaign!.limitations,
          this.campaignBasicFormModel
        );
      }
      if (this.isCampaignInvalid()) {
        this.to404();
        return;
      }
    } catch (e) {
      const errorEvent = new ErrorEvent(
        'render-error',
        new Error('Failed to init campaign setup flow')
      );
      window.dispatchEvent(errorEvent);
    }
    this.updateState(false);
  }

  getDefaultLimitations() {
    const orderAgeMin: number =
      typeof this.order.ageMin === 'string'
        ? _.defaultTo(
            _.parseInt(this.order.ageMin),
            RTBCAMPAIGN_DEFAULT_AGE_MIN
          )
        : _.defaultTo(this.order.ageMin, RTBCAMPAIGN_DEFAULT_AGE_MIN);
    const orderAgeMax: number =
      typeof this.order.ageMax === 'string'
        ? _.defaultTo(
            _.parseInt(this.order.ageMax),
            RTBCAMPAIGN_DEFAULT_AGE_MAX
          )
        : _.defaultTo(this.order.ageMax, RTBCAMPAIGN_DEFAULT_AGE_MAX);
    const orderGender: FinalReportGender = _.defaultTo(
      this.order.gender,
      FinalReportGender.ALL
    );
    const ageLimitationPresets: Limitation[] = [
      {
        type: 'age_min',
        value: orderAgeMin
      },
      {
        type: 'age_max',
        value: orderAgeMax
      }
    ];
    const genderLimitationPresets: Limitation[] =
      orderGender !== FinalReportGender.ALL
        ? [
            {
              type: 'gender',
              value: [
                getGenderOptions().find(
                  (option) => option.value === orderGender
                )!
              ]
            }
          ]
        : [];
    const preferredLimitationPresets: Limitation[] = _.defaultTo(
      this.limitationPreSet.preferred,
      []
    );
    let limitationPreSet: Partial<LimitationData> = {
      ...this.limitationPreSet,
      preferred: [
        ...preferredLimitationPresets,
        ...ageLimitationPresets,
        ...genderLimitationPresets
      ]
    };
    if (this.campaignBasicFormModel) {
      const mergeLimitations = (
        limitationsA: Limitation[] = [],
        limitationsB: Limitation[] = []
      ): Limitation[] => {
        const map = new Map();
        limitationsA.forEach((item) => map.set(item.type, item));
        limitationsB.forEach((item) => map.set(item.type, item));
        return Array.from(map.values());
      };

      const defaultLimitationsOfAdType =
        this.campaignBasicFormModel.getDefaultLimitations();
      const operationSet =
        this.campaignBasicFormModel.limitationConfig.operationSet;
      return {
        include: mergeLimitations(
          limitationPreSet.include,
          defaultLimitationsOfAdType.include
        ),
        preferred: mergeLimitations(
          limitationPreSet.preferred,
          defaultLimitationsOfAdType.preferred
        ),
        nonPreferred: mergeLimitations(
          limitationPreSet.nonPreferred,
          defaultLimitationsOfAdType.nonPreferred
        ),
        exclude: mergeLimitations(
          limitationPreSet.exclude,
          defaultLimitationsOfAdType.exclude
        ),
        other: operationSet.other
          ? mergeLimitations(
              limitationPreSet.other,
              defaultLimitationsOfAdType.other
            )
          : []
      };
    }
    return {
      include: _.defaultTo(limitationPreSet.include, []),
      exclude: _.defaultTo(limitationPreSet.exclude, []),
      preferred: _.defaultTo(limitationPreSet.preferred, []),
      nonPreferred: _.defaultTo(limitationPreSet.nonPreferred, []),
      other: _.defaultTo(limitationPreSet.other, [])
    };
  }

  async initSavedTAList() {
    // TODO 未來必須要支援動態建立的 channel
    if (
      !Object.values(L1ObjectChannel)
        .map((value) => value.toString())
        .includes(this.l1Object.channel)
    ) {
      this.savedTAList = [];
      return;
    }
    try {
      this.savedTAList = await this.limitationManager.getSavedTargetings(
        this.order.advertiserId,
        _.get(this.l1Object, 'channel', ChannelGroupSetting.RTB.key),
        this.order.orderType
      );
    } catch (e) {}
  }

  setShowTAManagement = (showTAManagement: boolean): void => {
    this.showTAManagement = showTAManagement;
    this.updateState(false);
  };

  refreshSavedTAList = async () => {
    this.updateState(true);
    try {
      this.savedTAList = await this.limitationManager.getSavedTargetings(
        this.order.advertiserId,
        _.get(this.l1Object, 'channel', ChannelGroupSetting.RTB.key),
        this.order.orderType
      );
    } catch (e) {}
    this.updateState(false);
  };

  get needSetupTracking() {
    if (!this.campaignBasicFormModel) {
      return false;
    }

    const addonEnable =
      this.addonFeatureManager.isFeatureEnable(
        ADDONFEATURE.CONVERSION_TRACKING.CONV_TRACKING_LIST
      ) ||
      this.addonFeatureManager.isFeatureEnable(
        ADDONFEATURE.CAMPAIGN.THIRDPARTY_TRACKING
      ) ||
      this.addonFeatureManager.isFeatureEnable(
        ADDONFEATURE.CAMPAIGN.RETARGETING_TRACKER
      );

    return addonEnable;
  }

  get estimatedAudience() {
    return this.limitationModel ? this.limitationModel.estimateData : undefined;
  }

  get audienceLowestThreshold() {
    return 5000000;
  }

  get isPmp() {
    return this.campaignBasicFormModel
      ? this.campaignBasicFormModel.isPmpType
      : false;
  }

  initCreativeModels = async (campaign: RtbCampaign) => {
    const sameAdType = campaign.basic.adTypeId
      ? campaign.basic.adTypeId ===
        this.createCreativeFlowModel?.campaign.basic.adTypeId
      : campaign.basic.adType ===
        this.createCreativeFlowModel?.campaign.basic.adType;

    if (!this.createCreativeFlowModel || !sameAdType) {
      if (this.createCreativeFlowModel) {
        this.createCreativeFlowModel.onUnmount(this.createCreativeEventHandler);
      }
      this.createCreativeFlowModel =
        new CreateCreativeInL2ObjectSetupFlowPageModel(
          false,
          [],
          this.addonFeatureManager,
          {
            type: AdLogoType.DEFAULT
          },
          campaign,
          this.l1Object,
          this.order
        );
      await this.createCreativeFlowModel.init();
      this.createCreativeEventHandler = this.createCreativeFlowModel.event.add(
        () => {
          /* no-op */
        }
      );
    }

    if (
      !this.bindCreativeFlowModel ||
      this.bindCreativeFlowModel.campaign.basic.adType !== campaign.basic.adType
    ) {
      if (this.bindCreativeFlowModel) {
        this.bindCreativeFlowModel.onUnmount(this.bindCreativeEventHandler);
      }
      this.bindCreativeFlowModel = new BindCreativeInL2ObjectSetupFlowPageModel(
        false,
        [],
        this.addonFeatureManager,
        {
          type: AdLogoType.DEFAULT
        },
        campaign,
        this.order,
        this.l1Object,
        this.isPmp
      );
      await this.bindCreativeFlowModel.init();
      this.bindCreativeEventHandler = this.bindCreativeFlowModel.event.add(
        () => {
          /* no-op */
        }
      );
    }
  };

  initBidStrategy() {
    if (!this.campaign) {
      return;
    }
    if (this.l1Object.autoOptimise) {
      _.set(this.campaign, 'basic.bidStrategy', this.l1Object.rtb.bid_strategy);
    } else {
      _.set(
        this.campaign,
        'basic.bidStrategy',
        _.isNumber(_.get(this.campaign, 'basic.bidPrice'))
          ? BidStrategy.LOWEST_COST_WITH_BID_CAP
          : BidStrategy.LOWEST_COST_WITHOUT_CAP
      );
    }
  }

  /**
   * 電子紙看板的活動把「投放端沒有調整空間」的欄位藏起來（見 RtbCampaignBasicFormModel
   * 的 onlyDaypartingOptimize / canUseDailyBudget / showDeliverType /
   * hideFixOutdoorSpace），這裡負責把值一併校正成預設值。
   *
   * 校正放在 init 這個源頭而不是各個表單元件裡：欄位藏起來後就沒有人幫使用者改回合法值，
   * 而 create / edit / copy / draft 四條流程都會經過這裡，Formik 的 initialValues、草稿、
   * 摘要頁與送後端的 payload 讀的都是同一份 campaign.basic。只動電子紙，其他渠道照舊。
   */
  initHiddenFieldsOfEpaperCampaign() {
    if (!this.campaign || !isEpaperChannelGroup(this.l1Object.channelGroupId)) {
      return;
    }
    // 預算分配：只能全走期平均分配，等於不指定每日預算。
    _.set(this.campaign, 'basic.dailyTargetBudget', undefined);
    // 投遞速率：換頁節奏由看板決定，一律標準投遞。
    _.set(this.campaign, 'basic.deliverType', DeliverType.STANDARD);
    // 固定機台：電子紙一個渠道就是一批固定看板，沒有挑機台這件事。
    _.set(this.campaign, 'basic.fixOutdoorSpace', false);
  }

  getRtbCampaignSummaryStepModel(
    subStepIndex: number,
    goLast: () => void,
    goStep: (stepIndex: number, subStepIndex?: number) => void,
    goSubStep: (subStepIndex: number) => void,
    creativeSummaryStepModel?: CreativeSummaryStepModel
  ) {
    if (
      this.campaignSummaryModel &&
      this.campaignSummaryModel.subStepIndex === subStepIndex &&
      this.campaignSummaryModel.creativeSummaryStepModel ===
        creativeSummaryStepModel
    ) {
      return this.campaignSummaryModel;
    }
    this.campaignSummaryModel = new DefaultRtbCampaignSummaryStepModel(
      this,
      subStepIndex,
      goLast,
      goStep,
      goSubStep,
      creativeSummaryStepModel
    );
    return this.campaignSummaryModel;
  }

  getLimitationsSummaryData = (limitations): any => {
    const supportAgeGender =
      this.campaignBasicFormModel?.limitationConfig.supportAgeGenderLimitation;
    const limitationSummaryData = this.manager.getLimitationSummaryData(
      limitations,
      this.order.orderType,
      _.get(
        this.localeMeta,
        'property.addonProps.agencySegmentLimitationName',
        ''
      ),
      this.limitationModel
        ? this.limitationModel.limitationSetting
            .filter((setting) => setting.hideLimitation)
            .map((setting) => setting.name)
            .concat(supportAgeGender ? [] : ['age_min', 'age_max'])
        : []
    );
    const operationSet =
      this.campaignBasicFormModel!.limitationConfig.operationSet;
    const operations = Object.values(operationSet).flatMap((op) => op);
    return _.omitBy(
      {
        include: operations.includes(OPERATE.INCLUDE)
          ? {
              title: i18n.t('campaignSummary.titles.inc'),
              titlePrefixColor: SummaryTitleColor.GREEN,
              content: limitationSummaryData.include
            }
          : undefined,
        preferred: operations.includes(OPERATE.PREFERRED)
          ? {
              title: i18n.t('campaignSummary.titles.preferred'),
              titlePrefixColor: SummaryTitleColor.BLUE,
              content: limitationSummaryData.preferred
            }
          : undefined,
        nonPreferred: operations.includes(OPERATE.NONPREFERRED)
          ? {
              title: i18n.t('campaignSummary.titles.nonPreferred'),
              titlePrefixColor: SummaryTitleColor.YELLOW,
              content: limitationSummaryData.nonPreferred
            }
          : undefined,
        exclude: operations.includes(OPERATE.EXCLUDE)
          ? {
              title: i18n.t('campaignSummary.titles.exc'),
              titlePrefixColor: SummaryTitleColor.RED,
              content: limitationSummaryData.exclude
            }
          : undefined,
        other: limitationSummaryData.other
          ? {
              title: i18n.t('campaignSummary.titles.other'),
              content: limitationSummaryData.other
            }
          : undefined
      },
      _.isEmpty
    );
  };

  importLimitation = (
    appliedSavedTAInfo: SelectOptions,
    limitationValue: any
  ) => {
    if (!this.limitationModel) {
      return;
    }
    this.appliedSavedTAInfo = appliedSavedTAInfo;
    this.limitationModel.updateLimitationValue(limitationValue);
  };

  onDeleteSaveTA = (deletedTAId: number) => {
    if (
      this.appliedSavedTAInfo &&
      this.appliedSavedTAInfo.value === deletedTAId
    ) {
      this.appliedSavedTAInfo = undefined;
    }
    this.refreshSavedTAList();
  };

  setCampaign = (
    campaign: RtbCampaignFormData,
    rerender: boolean | undefined = true
  ) => {
    this.campaign = campaign;
    rerender && this.updateState(false);
  };

  setOrder = (order: Order) => {
    this.order = { ...order };
  };

  get state(): RtbCampaignSetupFlowPageState {
    return {
      loading: this.loading,
      redirectPath: this.redirectPath,
      campaign: this.campaign,
      finished: this.finished,
      showTAManagement: this.showTAManagement,
      creativeSetupStepData: this.creativeSetupStepData
    };
  }

  getCampaignFormModelParams(): RtbCampaignBasicFormModelConstructorParams {
    return [
      this.defaultCampaign,
      this.campaign!.basic,
      this.order,
      this.l1Object,
      this.addonFeatureManager,
      this.onPriceModelChange,
      this.otherCampaignOfL1Object
    ];
  }

  async onAdTypeChange(adType: string, adTypeId?: number) {
    this.updateState(true);
    if (
      this.campaign?.basic.adType !== adType ||
      this.campaign?.basic.adTypeId !== adTypeId
    ) {
      await this.setUpCampaignBasicFormModel(adType, adTypeId, false);
    }
    const defaultCampaign = _.cloneDeep(this.defaultCampaign);
    if (this.campaignBasicFormModel) {
      const optimize = this.campaignBasicFormModel.getDefaultOptimizeType(
        this.campaignBasicFormModel.defaultPriceModel
      );
      _.set(
        defaultCampaign,
        'basic.priceModel',
        this.campaignBasicFormModel.defaultPriceModel
      );
      this.campaignBasicFormModel.setCurrentPriceModel(
        this.campaignBasicFormModel.defaultPriceModel
      );
      _.set(defaultCampaign, 'basic.optimize', optimize);
      _.set(
        defaultCampaign,
        'basic.videoAdViewObjective',
        this.campaignBasicFormModel.getVideoAdViewObjectiveOptions(
          this.campaignBasicFormModel.defaultPriceModel
        )
          ? {
              videoAdEvent: VideoAdViewObjective.DEFAULT
            }
          : undefined
      );
      const hasOutdoorDeliverOptions =
        this.campaignBasicFormModel.outdoorDeliverTypeOptions !== undefined;
      if (
        this.manager.showFrequencyControl(
          this.l1Object,
          _.defaultTo(optimize, L2ObjectOptimizationGoal.UNSPECIFIED)
        )
      ) {
        _.set(defaultCampaign, 'basic.frequency', {
          maxFrequency: 5,
          intervalDays: 1
        });
      } else {
        _.set(defaultCampaign, 'basic.frequency', undefined);
      }
      _.set(
        defaultCampaign,
        'basic.outdoorDeliverType',
        hasOutdoorDeliverOptions ? OutdoorDeliverType.OPTIMIZE : undefined
      );
      const optimizeSameAsPriceModel = optimize
        ? this.manager.checkOptimizeSameAsPriceModel(
            this.campaignBasicFormModel.defaultPriceModel,
            optimize
          )
        : false;
      const onlyBidCap =
        (!this.addonFeatureManager.isFeatureEnable(
          perChannelCampaignKey(
            this.l1Object.channelGroupId,
            ADDONFEATURE.CAMPAIGN.ENABLE_OPTIMIZED_PRICE
          )
        ) &&
          optimizeSameAsPriceModel) ||
        this.campaignBasicFormModel.onlyBidCap;
      _.set(
        defaultCampaign,
        'basic.bidStrategy',
        onlyBidCap
          ? BidStrategy.LOWEST_COST_WITH_BID_CAP
          : BidStrategy.LOWEST_COST_WITHOUT_CAP
      );
      _.set(
        defaultCampaign,
        'basic.deliverType',
        this.campaignBasicFormModel.onlySupportAcceleratedDeliverType
          ? DeliverType.ACCELERATED
          : DeliverType.STANDARD
      );
      this.setupLimitationsByCampaignBasicFormModel(
        this.campaignBasicFormModel,
        defaultCampaign
      );
    }
    if (this.l1Object.autoOptimise) {
      _.set(
        defaultCampaign,
        'basic.bidStrategy',
        this.l1Object.rtb.bid_strategy
      );
    }
    const newCampaign = {
      ...defaultCampaign,
      basic: {
        ...defaultCampaign.basic,
        adType: adType,
        adTypeId: this.adTypeSetting?.adTypeId
      }
    };
    if (
      this.campaignBasicFormModel &&
      this.campaignBasicFormModel.canCreateWithCreative
    ) {
      await this.initCreativeModels(newCampaign);
      this.setCreativeSetupStepData(true);
    }
    this.setCampaign(newCampaign, true);
  }

  setRedirectPath(redirectPath?: string) {
    this.redirectPath = redirectPath;
    this.updateState(false);
  }

  setFinishedRedirectPath(redirectPath?: string) {
    this.redirectPath = redirectPath;
    this.finished = true;
    this.updateState(false);
  }

  setCreativeSetupStepData(_1: boolean) {
    /* no-op */
  }

  getRtbCampaignBasicFormModel(): RtbCampaignBasicFormModel | undefined {
    return this.campaignBasicFormModel;
  }

  async setUpCampaignBasicFormModel(
    adType: string,
    adTypeId?: number,
    needShowLoading = false
  ) {
    const channelGroupConfig = this.channelGroupSetting.config;
    this.adTypeSetting = channelGroupConfig.campaignAdTypeSettings.find(
      (setting) => {
        if (adTypeId) {
          return setting.adTypeId === adTypeId;
        }
        return setting.name === adType;
      }
    );
    if (channelGroupConfig.channelType === ChannelType.BEACON) {
      this.campaignBasicFormModel = this.campaignLineMessageFormModel;
    } else {
      switch (adType) {
        case AdType.VIDEO:
          this.campaignBasicFormModel = this.campaignVideoFormModel;
          break;
        case AdType.DISPLAY:
          this.campaignBasicFormModel = this.campaignDisplayFormModel;
          break;
        case AdType.THIRD_PARTY:
          this.campaignBasicFormModel = this.campaignThirdPartyFormModel;
          break;
        case AdType.THIRD_PARTY_BOTTOM:
          this.campaignBasicFormModel = this.campaignThirdPartyBottomFormModel;
          break;
        case AdType.THIRD_PARTY_RECTANGLE:
          this.campaignBasicFormModel =
            this.campaignThirdPartyRectangleFormModel;
          break;
        case AdType.SANDBOX_OUTDOOR:
          this.campaignBasicFormModel = this.campaignSandboxOutdoorFormModel;
          break;
        case AdType.COMBO:
          this.campaignBasicFormModel = this.campaignComboFormModel;
          break;
        case AdType.ONE_FOR_ALL_DISPLAY:
          this.campaignBasicFormModel = this.campaignOneForAllDisplayFormModel;
          break;
        case AdType.CTV:
          this.campaignBasicFormModel = this.campaignCtvFormModel;
          break;
        case AdType.SANDBOX_MOVABLE_OUTDOOR:
          this.campaignBasicFormModel =
            this.campaignSandboxMovableOutdoorFormModel;
          break;
        case 'PMP':
          this.campaignBasicFormModel = this.campaignPmpFormModel;
          break;
        default:
          if (
            this.channelGroupSetting.config.channelType ===
            ChannelType.MOVABLE_OUTDOOR
          ) {
            this.campaignBasicFormModel =
              this.campaignDynamicMovableOutdoorFormModel;
          } else if (
            this.adTypeSetting?.screenDisplayType ===
            ScreenDisplayType.SYNCHRONIZED_PLAYBACK
          ) {
            this.campaignBasicFormModel =
              this.campaignDynamicOutdoorSynchronizedPlaybackFormModel;
          } else if (
            this.channelGroupSetting.config.deliveryUnit === DeliveryUnit.STORE
          ) {
            this.campaignBasicFormModel =
              this.campaignDynamicOutdoorStoreFormModel;
          } else {
            this.campaignBasicFormModel =
              this.campaignDynamicOutdoorDeviceFormModel;
          }
          break;
      }
    }
    this.adTypeSetting &&
      this.campaignBasicFormModel!.setAdTypeSetting(this.adTypeSetting);
    // not determine adType yet
    if (adType !== 'PMP' && !this.adTypeSetting) {
      return;
    }
    needShowLoading && this.updateState(true);
    if (
      this.campaignBasicFormModel instanceof
        AbstractOutdoorLimitationCampaignFormModel &&
      this.campaign
    ) {
      // Establish testMode before init() so it fetches the right data once,
      // instead of fetching with the default and refetching via setTestMode.
      this.campaignBasicFormModel.setInitialTestMode(
        isTestMode(this.campaign.limitations)
      );
    }
    this.campaignBasicFormModel && (await this.campaignBasicFormModel.init());
    needShowLoading && this.updateState(false);
  }

  getRequiredOperatesOfLimitations() {
    const defaultCanNotNull = {
      include: ['adx']
    };
    const limitationPreSet = this.limitationPreSet ? this.limitationPreSet : {};
    Object.keys(defaultCanNotNull).forEach((opreate) => {
      _.remove(
        defaultCanNotNull[opreate],
        (value) =>
          !limitationPreSet[opreate] ||
          limitationPreSet[opreate].find(
            (element) => element.type === value
          ) === undefined
      );
    });

    const limitationsCanNotNull = _.omitBy(defaultCanNotNull, _.isEmpty);
    const requiredOperateOfTaTypes = {};
    Object.keys(limitationsCanNotNull).forEach((operate) => {
      const limitationCanNotNullOfOperate = limitationsCanNotNull[operate];
      limitationCanNotNullOfOperate &&
        limitationCanNotNullOfOperate.forEach((type) => {
          const requiredOperateOfTaType = _.defaultTo(
            requiredOperateOfTaTypes[type],
            []
          );
          requiredOperateOfTaType.push(operate);
          requiredOperateOfTaTypes[type] = requiredOperateOfTaType;
        });
    });
    return requiredOperateOfTaTypes;
  }

  getLimitationModel(needRefreshSetting: boolean): EditLimitationModel {
    this.limitationModel = this.getNormalLimitationModel(
      this.getRequiredOperatesOfLimitations(),
      needRefreshSetting
    );
    return this.limitationModel;
  }

  /**
   * Outdoor only: refresh saved limitation labels against the freshly-fetched
   * options. Server-side i18n means stored labels can differ from current
   * locale (e.g. saved as "Others_xxx" in EN, displayed in ZH session). Values
   * are the identity and stay untouched; only labels are overlaid. No-op when
   * the form model isn't an outdoor one (duck-typed via overlayLimitationLabels).
   */
  applyOutdoorLabelOverlay(
    limitations: LimitationData,
    campaignBasicFormModel: RtbCampaignBasicFormModel
  ): void {
    const labelMaps = (
      campaignBasicFormModel as Partial<OutdoorLimitaitonCampaignFormModel>
    ).spaceAttributeLabelMaps;
    if (!labelMaps) return;
    overlayLimitationData(limitations, labelMaps);
  }

  /**
   * Outdoor only: hand the saved limitation values to the form model so the
   * option panel can list stores/devices that have since dropped out of the
   * options tree (BANNED spaces are absent from store-options, and the test
   * pool has its own tree). No-op when the form model isn't an outdoor one.
   */
  rememberSelectedDeliveryTargets(
    limitations: LimitationData,
    campaignBasicFormModel: RtbCampaignBasicFormModel
  ): void {
    const remember = (
      campaignBasicFormModel as Partial<OutdoorLimitaitonCampaignFormModel>
    ).rememberSelectedDeliveryTargets;
    if (!remember) return;
    remember(limitations);
  }

  setupLimitationsByCampaignBasicFormModel(
    campaignBasicFormModel: RtbCampaignBasicFormModel,
    campaign: RtbCampaign
  ) {
    let limitationModel = this.getLimitationModel(false);
    let limitationSetting =
      campaignBasicFormModel.getLimitationInventorySetting(
        this.getRequiredOperatesOfLimitations(),
        this.campaign!.basic,
        this.localeMeta
      );

    limitationModel.setLimitationSetting(limitationSetting);
    limitationModel.setOperationSet(this.getCampaignOperationSet());
    limitationModel.setSupportAudienceEstimation(
      campaignBasicFormModel.limitationConfig.supportAudienceEstimation
    );

    const defaultLimitations = this.getDefaultLimitations();
    this.applyOutdoorLabelOverlay(defaultLimitations, campaignBasicFormModel);
    campaign.limitations = defaultLimitations;
    limitationModel.setLimitationValue(defaultLimitations);
    const defaultLimitationToShow =
      campaignBasicFormModel.limitationConfig.defaultLimitationToShow;
    defaultLimitationToShow &&
      limitationModel.showInventory(
        defaultLimitationToShow.name,
        defaultLimitationToShow.operate
      );
  }

  getCampaignOperationSet() {
    if (!this.campaignBasicFormModel) {
      return {
        need: [OPERATE.INCLUDE, OPERATE.PREFERRED, OPERATE.NONPREFERRED],
        notNeed: [OPERATE.EXCLUDE],
        other: [] as any
      };
    }
    return this.campaignBasicFormModel.limitationConfig.operationSet;
  }

  getNormalLimitationModel(
    requiredOperateOfTaTypes: {
      [type: string]: OPERATES[];
    },
    needRefreshSetting: boolean
  ) {
    if (!needRefreshSetting && this.normalLimitationModel) {
      return this.normalLimitationModel;
    }
    let limitationSetting = this.campaignBasicFormModel
      ? this.campaignBasicFormModel.getLimitationInventorySetting(
          requiredOperateOfTaTypes,
          this.campaign!.basic,
          this.localeMeta
        )
      : getDefaultLimitationInventorySettings(
          requiredOperateOfTaTypes,
          this.campaign!.basic.advertiserId,
          LIMITATION_TYPE.CAMPAIGN,
          this.localeMeta,
          this.campaign!.basic.adType,
          _.get(this.l1Object, 'channel', ChannelGroupSetting.RTB.key),
          true
        );

    if (!this.normalLimitationModel) {
      // For existing campaigns, saved limitations come in with labels frozen at
      // the locale they were saved in. Overlay fresh labels before constructing
      // the limitation model so the UI shows the current locale's labels.
      if (this.campaignBasicFormModel) {
        this.applyOutdoorLabelOverlay(
          this.campaign!.limitations,
          this.campaignBasicFormModel
        );
        // POS-8118：已存的門市／機台可能已經被 BANNED 而不在選項樹裡，選項面板要
        // 把它們補回來才看得到、取消得掉。
        this.rememberSelectedDeliveryTargets(
          this.campaign!.limitations,
          this.campaignBasicFormModel
        );
      }
      this.normalLimitationModel = new DefaultEditLimitationModel(
        limitationSetting,
        this.campaign!.limitations,
        this.getCampaignOperationSet(),
        this.addonFeatureManager.addonFeature,
        _.partial(this.setShowTAManagement, true),
        {
          channel: _.get(this.l1Object, 'channel', ChannelGroupSetting.RTB.key),
          audienceLowestThreshold: this.audienceLowestThreshold,
          channelTargetingGetter: this.getRtbTargeting,
          campaignDetailDataGetter: () => {
            if (!this.campaignBasicFormModel) {
              return;
            }
            return {
              campaign: this.campaignBasicFormModel.formikValue,
              order: this.order
            };
          }
        },
        _.get(
          this.campaignBasicFormModel,
          'limitationConfig.supportAudienceEstimation',
          false
        ),
        _.get(
          this.campaignBasicFormModel,
          'limitationConfig.requireIncludeLimitation',
          false
        )
      );
    }
    this.normalLimitationModel.setLimitationSetting(limitationSetting);
    return this.normalLimitationModel;
  }

  getRtbTargeting = (limitationValue) => {
    const includeLimitation = _.defaultTo(limitationValue.include, []);
    const preferredLimitation = _.defaultTo(limitationValue.preferred, []);
    const includeAgeMin = includeLimitation.find(
      (limitation) => limitation.type === 'age_min'
    );
    const ageMinLimitation =
      includeAgeMin ||
      preferredLimitation.find((limitation) => limitation.type === 'age_min');
    const ageMin = _.get(ageMinLimitation, 'value', 18);
    const includeAgeMax = includeLimitation.find(
      (limitation) => limitation.type === 'age_max'
    );
    const ageMaxLimitation =
      includeAgeMax ||
      preferredLimitation.find((limitation) => limitation.type === 'age_max');
    const ageMax = _.get(ageMaxLimitation, 'value', 61);
    const ageOptValue = includeAgeMin ? 'include' : 'preferred';
    const ages = getPmax2RtbAgeGroupsByAgeRange(ageMin, ageMax);
    const otherLimitations = toServerStructure(limitationValue).filter(
      (limitation) =>
        (limitation.op === 'inc' &&
          ['gender', 'segment'].includes(limitation.type)) ||
        (limitation.op === 'Preferred' && limitation.type === 'gender') ||
        (limitation.op === 'exc' && limitation.type === 'segment')
    );
    otherLimitations.push({
      op: ageOptValue === 'include' ? 'inc' : 'Preferred',
      limits: ages,
      isGroup: false,
      type: 'age'
    });
    return otherLimitations;
  };

  onPriceModelChange = (priceModel, currentCampaignBasic) => {
    if (!this.campaignBasicFormModel) {
      return;
    }
    const limitationModel = this.getLimitationModel(false);
    const optimize =
      this.campaignBasicFormModel.getDefaultOptimizeType(priceModel);
    const needFrequency = optimize
      ? this.manager.showFrequencyControl(this.l1Object, optimize)
      : false;
    const optimizeSameAsPriceModel = optimize
      ? this.manager.checkOptimizeSameAsPriceModel(priceModel, optimize)
      : false;
    const onlyBidCap =
      (!this.addonFeatureManager.isFeatureEnable(
        perChannelCampaignKey(
          this.l1Object.channelGroupId,
          ADDONFEATURE.CAMPAIGN.ENABLE_OPTIMIZED_PRICE
        )
      ) &&
        optimizeSameAsPriceModel) ||
      this.campaignBasicFormModel.onlyBidCap;
    const needVideoAdViewObjective =
      this.campaignBasicFormModel.getVideoAdViewObjectiveOptions(priceModel) !==
      undefined;
    this.setCampaign({
      basic: {
        ...currentCampaignBasic,
        priceModel,
        optimize,
        orderPrice: undefined,
        bidPrice: undefined,
        bidStrategy: this.l1Object.autoOptimise
          ? this.l1Object.rtb.bid_strategy
          : onlyBidCap
            ? BidStrategy.LOWEST_COST_WITH_BID_CAP
            : BidStrategy.LOWEST_COST_WITHOUT_CAP,
        frequency: needFrequency
          ? {
              maxFrequency: 5,
              intervalDays: 1
            }
          : undefined,
        videoAdViewObjective: needVideoAdViewObjective
          ? currentCampaignBasic.videoAdViewObjective
            ? currentCampaignBasic.videoAdViewObjective
            : {
                videoAdEvent: VideoAdViewObjective.DEFAULT
              }
          : undefined
      },
      limitations: limitationModel.limitationValue
    });
  };

  cancel = () => {
    const redirectPath = `/orders/${this.order.orderNumber}/campaign-groups/${this.l1Object.l1ObjectId}`;
    this.setRedirectPath(redirectPath);
  };

  onUnmount(handler) {
    this.event.remove(handler);
    this.redirectPath = undefined;
    this.campaign = undefined;
    this.rbLimitationModel = undefined;
    this.normalLimitationModel = undefined;
    this.campaignSummaryModel = undefined;
    this.finished = false;
    if (this.createCreativeFlowModel) {
      this.createCreativeFlowModel.onUnmount(this.createCreativeEventHandler);
      this.createCreativeFlowModel = undefined;
    }
    if (this.bindCreativeFlowModel) {
      this.bindCreativeFlowModel.onUnmount(this.bindCreativeEventHandler);
      this.bindCreativeFlowModel = undefined;
    }
  }

  updateState(loading: boolean) {
    this.loading = loading;
    this.event.fireEvent(this);
  }
}

abstract class CreateFlowPageModel extends DefaultRtbCampaignSetupFlowPageModel {
  createCampaignFormModels() {
    const params = this.getCampaignFormModelParams();
    this.campaignDisplayFormModel = new CreateDisplayFormModel(...params);
    this.campaignVideoFormModel = new CreateVideoFormModel(...params);
    this.campaignThirdPartyFormModel = new CreateThirdPartyFormModel(...params);
    this.campaignThirdPartyBottomFormModel =
      new CreateThirdPartyBottomFormModel(...params);
    this.campaignThirdPartyRectangleFormModel =
      new CreateThirdPartyRectangleFormModel(...params);
    this.campaignSandboxOutdoorFormModel = new CreateSandboxOutdoorFormModel(
      ...params
    );
    this.campaignComboFormModel = new CreateComboFormModel(...params);
    this.campaignUnknowAdTypeFormModel = new CreateUnknowAdTypeFormModel(
      ...params
    );
    this.campaignCtvFormModel = new CreateCtvFormModel(...params);
    this.campaignPmpFormModel = new CreatePmpFormModel(this.pmpList, ...params);
    this.campaignLineMessageFormModel = new CreateLineMessageFormModel(
      this.channelGroupSetting,
      ...params
    );
    this.campaignDynamicOutdoorDeviceFormModel =
      new CreateDynamicOutdoorDeviceFormModel(
        this.channelGroupSetting,
        ...params
      );
    this.campaignDynamicOutdoorStoreFormModel =
      new CreateDynamicOutdoorStoreFormModel(
        this.channelGroupSetting,
        ...params
      );
    this.campaignDynamicOutdoorSynchronizedPlaybackFormModel =
      new CreateDynamicOutdoorSynchronizedPlaybackFormModel(
        this.channelGroupSetting,
        ...params
      );
    this.campaignSandboxMovableOutdoorFormModel =
      new CreateSandboxMovableOutdoorFormModel(...params);
    this.campaignDynamicMovableOutdoorFormModel =
      new CreateDynamicMovableOutdoorFormModel(
        this.channelGroupSetting,
        ...params
      );
  }

  override to404() {
    const redirectPath = `/orders/${this.order.orderNumber}/campaign-groups/${this.l1Object.l1ObjectId}/campaigns/new/error404`;
    this.setRedirectPath(redirectPath);
  }

  override isCampaignInvalid() {
    if (this.order.state === State.SETTLED) {
      return true;
    }
    return false;
  }
}

abstract class CreateFlowFromExistOnePageModel extends CreateFlowPageModel {
  constructor(
    protected modalCampaignId: number,
    ...args: ConstructorParameters<typeof DefaultRtbCampaignSetupFlowPageModel>
  ) {
    super(...args);
    this.modalCampaignId = modalCampaignId;
  }
}

abstract class EditFlowPageModel extends DefaultRtbCampaignSetupFlowPageModel {
  constructor(
    protected modalCampaignId: number,
    ...args: ConstructorParameters<typeof DefaultRtbCampaignSetupFlowPageModel>
  ) {
    super(...args);
    this.modalCampaignId = modalCampaignId;
  }

  createCampaignFormModels() {
    const params = this.getCampaignFormModelParams();
    this.campaignOneForAllDisplayFormModel = new EditOneForAllDisplayFormModel(
      ...params
    );
    this.campaignDisplayFormModel = new EditDisplayFormModel(...params);
    this.campaignVideoFormModel = new EditVideoFormModel(...params);
    this.campaignThirdPartyFormModel = new EditThirdPartyFormModel(...params);
    this.campaignThirdPartyBottomFormModel = new EditThirdPartyBottomFormModel(
      ...params
    );
    this.campaignThirdPartyRectangleFormModel =
      new EditThirdPartyRectangleFormModel(...params);
    this.campaignSandboxOutdoorFormModel = new EditSandboxOutdoorFormModel(
      ...params
    );
    this.campaignComboFormModel = new EditComboFormModel(...params);
    this.campaignUnknowAdTypeFormModel = new EditUnknowAdTypeFormModel(
      ...params
    );
    this.campaignCtvFormModel = new EditCtvFormModel(...params);
    this.campaignPmpFormModel = new EditPmpFormModel(this.pmpList, ...params);
    this.campaignLineMessageFormModel = new EditLineMessageFormModel(
      this.channelGroupSetting,
      ...params
    );
    this.campaignDynamicOutdoorDeviceFormModel =
      new EditDynamicOutdoorDeviceFormModel(
        this.channelGroupSetting,
        ...params
      );
    this.campaignDynamicOutdoorStoreFormModel =
      new EditDynamicOutdoorStoreFormModel(this.channelGroupSetting, ...params);
    this.campaignDynamicOutdoorSynchronizedPlaybackFormModel =
      new EditDynamicOutdoorSynchronizedPlaybackFormModel(
        this.channelGroupSetting,
        ...params
      );
    this.campaignSandboxMovableOutdoorFormModel =
      new EditSandboxMovableOutdoorFormModel(...params);
    this.campaignDynamicMovableOutdoorFormModel =
      new EditDynamicMovableOutdoorFormModel(
        this.channelGroupSetting,
        ...params
      );
  }

  override to404() {
    const redirectPath = `/orders/${this.order.orderNumber}/campaign-groups/${this.l1Object.l1ObjectId}/campaigns/${this.campaignId}/edit/error404`;
    this.setRedirectPath(redirectPath);
  }

  override isCampaignInvalid() {
    if (this.isPmp) {
      return true;
    }

    if (this.order.state === State.SETTLED) {
      return true;
    }

    if (this.campaign!.basic.isDraft) {
      return false;
    }

    return (
      this.campaign!.basic.goGanGroupId !==
        _.get(this.l1Object, 'rtb.group_id') ||
      this.campaign!.basic.state === CampaignState.DELETE
    );
  }
}

export class CreateRtbCampaignSetupFlowPageModel extends CreateFlowPageModel {
  get type() {
    return 'create';
  }

  get campaignId() {
    return null;
  }

  async init() {
    this.updateState(true);
    try {
      const startDate = this.getCampaignStartDay();
      const endDate = this.getCampaignEndDay();
      this.pmpList = (
        await this.pmpManager.getPmpsByL1ObjectId(this.l1Object.l1ObjectId, [
          PmpStatus.ACTIVE
        ])
      ).filter(
        (pmp) =>
          moment(pmp.startTime).isBefore(endDate) &&
          moment(pmp.endTime).isAfter(startDate)
      );
      await super.init();
    } catch (e) {
      console.error(e);
    }
    this.updateState(false);
  }

  getTitle() {
    return i18n.t('campaign.labels.createCampaignTitle');
  }

  async getCampaign() {
    const startDate = this.getCampaignStartDay();
    const endDate = this.getCampaignEndDay();
    const scheduleDateCount = endDate.diff(startDate, 'days') + 1;
    const minBudgetOfCampaign =
      this.order.campaignConstraint.budgetMinimum * scheduleDateCount;
    const parentBidStrategy = _.get(this.l1Object, 'rtb.bid_strategy');
    const autoOptimise = _.get(this.l1Object, 'autoOptimise', false);
    const dateFormat = 'YYYY-MM-DD HH:mm:ss';
    const campaign = {
      basic: {
        advertiserId: this.order.advertiserId,
        budget: autoOptimise
          ? minBudgetOfCampaign
          : this.l1Object.budgetBalance,
        checkpoints: [],
        creativeDeliverType: CreativeDeliverType.OPTIMIZE,
        dailyTargetBudget: null,
        tags: [],
        name: this.l1Object.name,
        orderId: this.order.id,
        startDate: startDate.format(dateFormat),
        endDate: endDate.format(dateFormat),
        priceModel: RtbCampaignPlanType.RS,
        optimize: L2ObjectOptimizationGoal.CLICKS,
        enableMonitor: true,
        deliverType: DeliverType.STANDARD,
        convTrackEvent: TrackEvent.CLICK,
        expectedSpent: 0,
        orderPriceEnable: true,
        bidPrice:
          parentBidStrategy &&
          parentBidStrategy === BidStrategy.LOWEST_COST_WITH_BID_CAP
            ? 0
            : undefined,
        goGanGroupId: _.get(this.l1Object, 'rtb.group_id')
      },
      limitations: _.cloneDeep(this.getDefaultLimitations())
    };

    return campaign;
  }

  getCampaignStartDay() {
    const now = moment().startOf('hour');
    const orderStartDate = moment(this.order.startDate);
    return now.isBefore(orderStartDate) ? orderStartDate : now;
  }

  getCampaignEndDay() {
    return moment.min(
      moment(this.order.endDate).add(1, 'days').subtract(1, 'seconds'),
      this.getCampaignStartDay().add(91, 'days').endOf('day')
    );
  }

  setCreativeSetupStepData(createNewCreative: boolean) {
    if (!this.campaignBasicFormModel?.canCreateWithCreative) {
      return;
    }
    this.creativeSetupStepData = {
      component: createNewCreative ? CreateCreativeStep : BindCreativeStep,
      props: {
        model: createNewCreative
          ? this.createCreativeFlowModel
          : this.bindCreativeFlowModel,
        forPmp: this.isPmp
      }
    };
    this.updateState(false);
  }
}

export class EditRtbCampaignSetupFlowPageModel extends EditFlowPageModel {
  get type() {
    return 'edit';
  }

  get campaignId() {
    return this.modalCampaignId;
  }

  async getCampaign() {
    return this.manager.getCampaign(this.modalCampaignId);
  }

  getTitle() {
    return i18n.t('campaign.labels.editCampaignTitle');
  }
}

export class CopyRtbCampaignSetupFlowPageModel extends CreateFlowFromExistOnePageModel {
  get type() {
    return 'copy';
  }

  get campaignId() {
    return this.modalCampaignId;
  }

  async getCampaign() {
    const campaign = await this.manager.getNoCidCampaign(this.campaignId);
    const oldCampaign = _.cloneDeep(campaign);
    campaign.basic.orderPriceEnable = true;
    campaign.basic.spents = 0;
    campaign.basic.expectedSpent = 0;
    const oldCampaignIsStart = moment().isAfter(oldCampaign.basic.startDate);
    const oldCampaignIsEnd = moment().isAfter(oldCampaign.basic.endDate);
    if (oldCampaignIsStart) {
      campaign.basic.startDate = moment()
        .startOf('hours')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    if (oldCampaignIsEnd) {
      campaign.basic.endDate = moment(this.order.endDate)
        .endOf('day')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    if (this.l1Object.autoOptimise) {
      campaign.basic.budget = this.manager.getMinBudgetOfCampaign(
        campaign.basic,
        this.order.campaignConstraint.budgetMinimum
      );
    }
    return campaign;
  }

  getTitle() {
    return i18n.t('campaign.labels.copyCampaignTitle');
  }
}

export class SplitRtbCampaignSetupFlowPageModel extends CreateFlowFromExistOnePageModel {
  get type() {
    return 'split';
  }

  get campaignId(): number | null {
    return this.modalCampaignId;
  }

  async getCampaign() {
    const campaign = await this.manager.getNoCidCampaign(this.modalCampaignId);
    const oldCampaign = _.cloneDeep(campaign);

    campaign.basic.orderPriceEnable = true;
    campaign.basic.expectedSpent = 0;
    campaign.basic.spents = 0;
    campaign.basic.state = CampaignState.ACTIVATE;

    const isOldCampaignActive =
      oldCampaign.basic.state !== CampaignState.DEACTIVATE;
    const isAutoOptimise = this.l1Object.autoOptimise;
    const oldCampaignMinBudget = isOldCampaignActive
      ? Math.max(
          isAutoOptimise
            ? this.manager.getMinBudgetOfCampaign(
                oldCampaign.basic,
                this.order.campaignConstraint.budgetMinimum
              )
            : this.order.campaignConstraint.campaignBudgetMinimum,
          oldCampaign.basic.expectedSpent
        )
      : _.defaultTo(oldCampaign.basic.spents, 0);
    const oldCampaignSpent = isOldCampaignActive
      ? oldCampaign.basic.expectedSpent
      : _.defaultTo(oldCampaign.basic.spents, 0);
    const newCampaignBudget =
      oldCampaignSpent > oldCampaign.basic.budget
        ? 0
        : getPriceValue(
            this.order.currency,
            oldCampaign.basic.budget - oldCampaignMinBudget
          );
    this.l1Object.budgetBalance = newCampaignBudget;
    const oldCampaignIsStart = moment().isAfter(oldCampaign.basic.startDate);
    const oldCampaignIsEnd = moment().isAfter(oldCampaign.basic.endDate);
    if (oldCampaignIsStart) {
      campaign.basic.startDate = moment()
        .startOf('hours')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    if (oldCampaignIsEnd) {
      campaign.basic.endDate = moment(this.order.endDate)
        .endOf('day')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    campaign.basic.budget = this.l1Object.autoOptimise
      ? this.manager.getMinBudgetOfCampaign(
          campaign.basic,
          this.order.campaignConstraint.budgetMinimum
        )
      : newCampaignBudget;

    return campaign;
  }

  getTitle() {
    return i18n.t('campaign.labels.splitCampaignTitle');
  }
}

export class EditRtbCampaignDraftSetupFlowPageModel extends CreateRtbCampaignSetupFlowPageModel {
  constructor(
    private draftId: string,
    order: Order,
    addonFeatureManager: AddonFeatureManager,
    l1Object: L1Object,
    localeMeta?: LocaleMeta,
    otherCampaignOfL1Object?: RtbCampaignListBasic[],
    private draftManager: DraftManager = new RtbCampaignDraftManager()
  ) {
    super(
      order,
      addonFeatureManager,
      l1Object,
      localeMeta,
      otherCampaignOfL1Object
    );
    this.objectType = 'draft';
  }

  get type() {
    return 'edit';
  }

  getTitle() {
    return i18n.t('campaign.labels.editCampaignDraftTitle');
  }

  async getCampaign() {
    return this.draftManager.getDraft(
      this.l1Object.channelGroupId,
      this.draftId
    );
  }

  getRtbCampaignSummaryStepModel(
    subStepIndex: number,
    goLast: () => void,
    goStep: (stepIndex: number, subStepIndex?: number) => void,
    goSubStep: (subStepIndex: number) => void
  ) {
    if (this.campaignSummaryModel) {
      return this.campaignSummaryModel;
    }
    this.campaignSummaryModel = new RtbCampaignDraftSummaryStepModel(
      this.draftId,
      this,
      subStepIndex,
      goLast,
      goStep,
      goSubStep,
      this.draftManager
    );
    return this.campaignSummaryModel;
  }

  onSaveDraft = async (campaign: RtbCampaign) => {
    this.updateState(true);
    try {
      await this.draftManager.updateDraft(
        this.l1Object.channelGroupId,
        this.draftId,
        this.manager.prepareCreateCampaignPayload(campaign)
      );
      toast.success(i18n.t('campaignSetupFlow.messages.updateDraftSuccess'));
    } catch (e) {
      toast.error(i18n.t('campaignSetupFlow.messages.updateDraftFailed'));
    }
    this.updateState(false);
  };
}

export class SummaryRtbCampaignFlowPageModel extends EditFlowPageModel {
  get type() {
    return 'summary';
  }

  get campaignId(): number | null {
    return this.modalCampaignId;
  }

  getTitle() {
    return i18n.t('campaign.labels.summaryCampaignTitle');
  }

  async getCampaign() {
    return this.manager.getCampaign(this.modalCampaignId);
  }

  override isCampaignInvalid() {
    return false;
  }
}
